import { cn } from "@/utils/styles";

export const COOKIE_DIALOG_POSITION = cn(
  `top-[calc(100%)] lg:top-[calc(100%-110px)] translate-y-[-100%] data-[state=closed]:slide-out-to-left-full data-[state=open]:slide-in-from-left-full`,
  `left-[calc(100%)] lg:left-[calc(100%-30px)] translate-x-[-100%] data-[state=closed]:slide-out-to-top-full data-[state=open]:slide-in-from-top-full`
);
